import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMedicalCross = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2.625 12C2.625 14.4864 3.61272 16.871 5.37087 18.6291C7.12903 20.3873 9.5136 21.375 12 21.375C14.4864 21.375 16.871 20.3873 18.6291 18.6291C20.3873 16.871 21.375 14.4864 21.375 12C21.375 9.5136 20.3873 7.12903 18.6291 5.37087C16.871 3.61272 14.4864 2.625 12 2.625C9.5136 2.625 7.12903 3.61272 5.37087 5.37087C3.61272 7.12903 2.625 9.5136 2.625 12V12Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 10.125H13.875V7C13.875 6.83424 13.8092 6.67527 13.6919 6.55806C13.5747 6.44085 13.4158 6.375 13.25 6.375H10.75C10.5842 6.375 10.4253 6.44085 10.3081 6.55806C10.1908 6.67527 10.125 6.83424 10.125 7V10.125H7C6.83424 10.125 6.67527 10.1908 6.55806 10.3081C6.44085 10.4253 6.375 10.5842 6.375 10.75V13.25C6.375 13.4158 6.44085 13.5747 6.55806 13.6919C6.67527 13.8092 6.83424 13.875 7 13.875H10.125V17C10.125 17.1658 10.1908 17.3247 10.3081 17.4419C10.4253 17.5592 10.5842 17.625 10.75 17.625H13.25C13.4158 17.625 13.5747 17.5592 13.6919 17.4419C13.8092 17.3247 13.875 17.1658 13.875 17V13.875H17C17.1658 13.875 17.3247 13.8092 17.4419 13.6919C17.5592 13.5747 17.625 13.4158 17.625 13.25V10.75C17.625 10.5842 17.5592 10.4253 17.4419 10.3081C17.3247 10.1908 17.1658 10.125 17 10.125Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMedicalCross.displayName = 'SvgMedicalCross';
export default SvgMedicalCross;
